import { nanoid } from 'nanoid'

export const SEGMENTS_SUBURBAN_CORRIDORS = {
  DEFAULT_BUILDING_HEIGHT_LEFT: 1,
  DEFAULT_BUILDING_HEIGHT_RIGHT: 1,
  DEFAULT_BUILDING_VARIANT_LEFT: 'residential',
  DEFAULT_BUILDING_VARIANT_RIGHT: 'residential',
  segments: [
    {
      type: 'divider',
      variant: { 'divider-type': 'planting-strip' },
      width: 13,
      id: nanoid()
    },
    {
      type: 'sidewalk',
      variant: { 'sidewalk-density': 'empty' },
      width: 8,
      id: nanoid()
    },

    {
      type: 'divider',
      variant: { 'divider-type': 'planting-strip' },
      width: 12,
      id: nanoid()
    },

    {
      type: 'drive-lane',
      variant: {
        direction: 'inbound',
        'car-type': 'car'
      },
      width: 11.5,
      id: nanoid()
    },
    {
      type: 'turn-lane',
      variant: { direction: 'outbound|shared' },
      width: 11,
      id: nanoid()
    },

    {
      type: 'drive-lane',
      variant: {
        direction: 'outbound',
        'car-type': 'car'
      },
      width: 11.5,
      id: nanoid()
    },
    {
      type: 'divider',
      variant: { 'divider-type': 'planting-strip' },
      width: 12,
      id: nanoid()
    },
    {
      type: 'sidewalk',
      variant: { 'sidewalk-density': 'empty' },
      width: 8,
      id: nanoid()
    },

    {
      type: 'divider',
      variant: { 'divider-type': 'planting-strip' },
      width: 13,
      id: nanoid()
    }
  ]
}
